import {
  MdMultilineChart,
  MdOutlineStackedLineChart,
  MdShowChart,
  MdOutlineAccountBalanceWallet,
  MdOutlineBusinessCenter,
  MdOutlineReceiptLong,
  MdOutlinePriceChange,
} from "react-icons/md";
import {
  GiRunningNinja,
  GiBull,
  GiExtraTime,
  GiTakeMyMoney,
} from "react-icons/gi";
import { HiCash, HiNewspaper } from "react-icons/hi";

const iconSize = 22;
export const technicalContents = [
  {
    id: 0,
    title: "MACD (12,26)",
    icon: <MdMultilineChart size={iconSize} />,
    description:
      "MACD é um indicador estatístico amplamente utilizado por analistas profissionais durante suas análises técnicas, este indicador utiliza linhas de média móvel convergente e divergente (12, 26 dias), é ótimo para detectar tendências de preços de curto prazo e médio prazo.",
    reliability: 5,
    period: "Curto/Médio prazo",
  },
  {
    id: 1,
    icon: <MdOutlineStackedLineChart size={iconSize} />,
    title: "Índice de direção de movimento",
    description:
      "ADX é um dos poucos indicadores que conseguem medir a força de uma tendência, é constituído por duas linhas de forças compradoras e vendedoras que conseguem determinar a tendência de preço, é um ótimo indicador para utilizar em conjunto com outros indicadores técnicos de curto prazo.",
    reliability: 3,
    period: "Curto prazo",
  },
  {
    id: 2,
    icon: <MdMultilineChart size={iconSize} />,
    title: "Índice de Força Relativa",
    description:
      "IFR é uma linha que funciona como um termômetro de cansaço do mercado, medindo se já subiu ou caiu muito e precisa tomar folego para continuar na mesma tendência, é um excelente indicador de curto prazo e médio prazo.",
    reliability: 4,
    period: "Curto/Médio Prazo",
  },
  {
    id: 3,
    icon: <GiBull size={iconSize} />,
    title: "Oscilador Bulls Power",
    description:
      "Bulls Power é um oscilador de força que consegue entrar na batalha de compradores e vendedores de um ativo e determinar qual força está vencendo e a tendência dessa força, é um bom indicador de momento, funciona muito bem quando utilizado em conjunto com outros indicadores de curto prazo.",
    reliability: 4,
    period: "Curto prazo",
  },
  {
    id: 4,
    icon: <GiExtraTime size={iconSize} />,
    title: "Indicador Momentum",
    description:
      "Momentum é um indicador capaz de determinar a força de compra ou venda de um ativo para determinado período, é um indicador simples e confiável que funciona muito bem quando utilizado em conjunto com outros indicadores de curto prazo.",
    reliability: 3,
    period: "Curto prazo",
  },
  {
    id: 5,
    icon: <MdMultilineChart size={iconSize} />,
    title: "IFR Estocástico",
    description:
      "IFR Estocástico é a fusão de dois excelentes indicadores técnicos, o índice de força relativa e o oscilador estocástico. Juntos trabalham rastreando os níveis de sobrecompra e sobrevenda e determinando a força do mercado.",
    reliability: 4,
    period: "Curto prazo",
  },
  {
    id: 6,
    icon: <MdShowChart size={iconSize} />,
    title: "Oscilador Ultimate",
    description:
      "Ultimate é um oscilador que tenta capturar o momento em três períodos diferentes, visando evitar as desvantagens vistas em outros osciladores que se baseiam apenas em um período, é um ótimo indicador que pode ser utilizado em conjunto com outros indicadores de curto prazo.",
    reliability: 5,
    period: "Curto prazo",
  },
  {
    id: 7,
    icon: <MdMultilineChart size={iconSize} />,
    title: "Indicador ATR",
    description:
      "ATR é um indicador técnico que sinaliza mudanças nos níveis de volatilidade de um ativo, com ele é possível obter sinais de grandes mudanças de preço.",
    reliability: 3,
    period: "Curto/Médio prazo",
  },
  {
    id: 8,
    icon: <GiExtraTime size={iconSize} />,
    title: "Williams %R Momento",
    description:
      "Williams %R é um indicador de momento que compara o preço de fechamento de um ativo, com relação ao valor mais alto e mais baixo dos últimos períodos, é um ótimo indicador para determinar sinais de compra e venda.",
    reliability: 4,
    period: "Curto/Médio prazo",
  },
  {
    id: 9,
    icon: <GiRunningNinja size={iconSize} />,
    title: "Estocástico (9,6)",
    description:
      "Estocástico é um indicador desenvolvido para mostrar a relação entre o preço de fechamento de um ativo, suas altas e mínimas durante certo período, ele não segue preço, volume nem tendência, ele segue a velocidade de movimento do preço, e, como regra, os movimentos no momento mudam antes do preço.",
    reliability: 5,
    period: "Curto/Médio prazo",
  },
];

export const fundamentalContents = [
  {
    id: 0,
    icon: <HiCash size={iconSize} />,
    title: "Fluxo de caixa operacional",
    description:
      "Este é um indicador fundamentalista de fluxo, é utilizado para representar todas entradas e saídas monetárias referentes a operação de uma empresa, através desse indicador entendemos como anda os lucros de uma empresa, os gastos causados por suas operações e o retorno sobre o investimento, além disso, se a empresa trabalha com vendas a prazo, este indicador consegue prever saltos de caixa e prever futuras demonstrações de fluxo.",
    reliability: 5,
    period: "Longo prazo",
  },
  {
    id: 1,
    icon: <MdOutlineAccountBalanceWallet size={iconSize} />,
    title: "Fluxo de Caixa Líquido (FCL)",
    description:
      "Este indicador fundamentalista representa como a empresa gerencia a quantidade de dinheiro disponível para realizações de negócios, é similar ao patrimonio liquido, porém, este é o dinheiro disponível para realização de negócios da empresa.",
    reliability: 4,
    period: "Longo prazo",
  },
  {
    id: 2,
    icon: <MdOutlineStackedLineChart size={iconSize} />,
    title: "Atividades de investimentos",
    description:
      "Este indicador fundamentalista se refere a atividades de investimentos que a empresa realiza a longo prazo, visando o lucro sobre as atividades. Empresas em ascensão, normalmente, realizam diversos investimentos e tendem a crescer muito a longo prazo.",
    reliability: 5,
    period: "Longo prazo",
  },
  {
    id: 3,
    icon: <MdOutlineBusinessCenter size={iconSize} />,
    title: "Balanço Patrimonial",
    description:
      "Balanço Patrimonial é um relatório contábil que descreve a situação financeira de uma empresa em determinado período, é um dos demonstrativos financeiros mais importantes, este relatório é calculado sobre todos os ativos e passivos de uma empresa, ou seja, seus bens, dividas e lucros.",
    reliability: 5,
    period: "Longo prazo",
  },
  {
    id: 4,
    icon: <MdOutlineAccountBalanceWallet size={iconSize} />,
    title: "Gerenciamento de contas",
    description:
      "Este indicador fundamentalista se refere a como uma empresa gerencia suas despesas fixas, não gerando endividamento e necessitando recorrer a empréstimos, é um indicador importante para determinar como a empresa lida com suas obrigatoriedades financeiras.",
    reliability: 5,
    period: "Longo prazo",
  },

  {
    id: 5,
    icon: <MdOutlineReceiptLong size={iconSize} />,
    title: "Geração de receita",
    description:
      "Este indicador fundamentalista se refere a como uma empresa consegue criar formas de geração de receita, normalmente, quanto mais uma empresa consegue criar formas de renda, mais tendem a crescer a longo prazo.",
    reliability: 5,
    period: "Longo prazo",
  },
  {
    id: 6,
    icon: <GiTakeMyMoney size={iconSize} />,
    title: "Lucros Líquidos",
    description:
      "Lucro Líquido é o rendimento de uma empresa que se obtém após realizar todos os descontos obrigatórios, tais como o custo total de operações e gastos fixos, é um importante indicador de saúde financeira de uma empresa.",
    reliability: 5,
    period: "Longo prazo",
  },
  {
    id: 7,
    icon: <MdOutlineReceiptLong size={iconSize} />,
    title: "Potencial de receita bruta",
    description:
      "Este indicador fundamentalista se refere ao potencial de faturamento bruto de uma empresa a longo prazo, sobre isso é calculado total de vendas, prestações de serviços e atividades de geração de renda. Assim conseguimos estipular seu potencial a longo prazo.",
    reliability: 4,
    period: "Longo prazo",
  },
  {
    id: 8,
    icon: <HiCash size={iconSize} />,
    title: "Receitas operacionais",
    description:
      "Este indicador fundamentalista mostra o quanto a empresa de fato gera receita com a sua operação. Sendo assim um indicador importante para entender se o negócio da empresa está crescendo ou não.",
    reliability: 5,
    period: "Longo prazo",
  },
];

export const extraContents = [
  {
    id: 0,
    icon: <HiNewspaper size={iconSize} />,
    title: "Sentimento do mercado",
    description:
      "Este indicador analisa as notícias e opiniões profissionais sobre o ativo e determina a percepção dos investidores, determinando assim o sentimento do mercado.",
    reliability: 3,
    period: "Médio/Longo prazo",
  },
  {
    id: 1,
    icon: null,
    title: "Notícias avaliadas",
    description: "",
    reliability: null,
    period: null,
  },
  {
    id: 2,
    icon: <MdOutlinePriceChange size={iconSize} />,
    title: "Avaliação de média de preço",
    description:
      "Este indicador analisa a média de preço do ativo, determinando sua tendência para negociação.",
    reliability: 4,
    period: "Curto/Médio/Longo prazo",
  },
  {
    id: 3,
    icon: <MdMultilineChart size={iconSize} />,
    title: "Médias Móveis - específico",
    description:
      "Este indicador analisa as médias moveis simples e exponenciais de acordo com seu tipo de investidor e consegue determinar tendências futuras. Este indicador é amplamente utilizado por profissionais, considerado um dos melhores indicadores técnicos do mercado.",
    reliability: 5,
    period: "Curto/Médio/Longo prazo",
  },
];
